const cosmeticConfig = {
  header: {
    MAX_IN_A_ROW: 4
  },
  menu_vertical: {
    MAX_IN_A_ROW: 12
  },
  tier: {
    OFFSET: 0,
    MAX: 15
  },
  company: {
    OFFSET: 0,
    MAX: 15
  },
  series: {
    OFFSET: 0,
    MAX: 15
  },
  expert: {
    OFFSET: 0,
    MAX: 15
  },
  reco_object_on_watchlist: {
    MAX_EXPERT: 5,
    MAX_COMPANY: 5,
    MAX_TOPIC: 5,
    MAX_SERIES: 5
  },
  reco_object_on_onboarding: {
    MAX_EXPERT: 5,
    MAX_COMPANY: 5,
    MAX_TOPIC: 10,
    MAX_SERIES: 5
  },
  foryou: {
    OFFSET: 0,
    MAX: 15
  },
  search: {
    OFFSET: 0,
    MAX: 15
  },
  global: {
    SITE_SALT: '_ausbiz_secret'
  }
};

module.exports = cosmeticConfig;
